import Header from '../../../../Components/Header'
import Footer from '../../../../Components/Footer'
import GateEntryComp from '../Components/GateEntryComp'
import { Helmet } from 'react-helmet';

const GateEntryList = () => {
  
  return (
		<div className="d-flex flex-column" style={{ minHeight: "99.7vh" }}>
			<Helmet>
				<title>Gate Entry List</title>
			</Helmet>
			<Header />
			<GateEntryComp />
			{/* <Footer /> */}
		</div>
	);
}

export default GateEntryList